import { lazy } from 'react';
import { createBrowserRouter, createRoutesFromElements, Route, type RouteObject } from 'react-router';
import { FallbackError } from '../components/FallbackError/FallbackError';
import { SuspendedWithSpinner } from '../components/SuspendedWithSpinner/SuspendedWithSpinner';
import { AppLayout } from '../containers/AppLayout/AppLayout';
import {
    DEFAULT_ROUTE,
    TOUR_HANDLING_DETAILS,
    TOUR_HANDLING_ROUTE,
    SUMMARY_ROUTE,
    TOUR_SETTINGS_ROUTE,
    VEHICLE_ROUTE,
} from '../common/constants';
import { TourDetailsManagerPage } from '../pages/TourDetailsManagerPage/TourDetailsManagerPage';
import { RouteSummaryPage } from '../pages/RouteSummaryPage/RouteSummaryPage';
import { TourHandlingPage } from '../pages/TourHandlingPage/TourHandlingPage';
import { TourSettingsPage } from '../pages/TourSettingsPage/TourSettingsPage';
import { VehicleOptionsPage } from '../pages/VehicleOptionsPage/VehicleOptionsPage';

const RouteSettingsPageLazy = lazy(() =>
    import('../pages/RouteSettingsPage/RouteSettingsPage').then(({ RouteSettingsPage }) => ({
        default: RouteSettingsPage,
    }))
);

export const routes = [DEFAULT_ROUTE, SUMMARY_ROUTE, VEHICLE_ROUTE];

export const routeObjects: RouteObject[] = createRoutesFromElements(
    <Route path='/' element={<AppLayout />} errorElement={<FallbackError />}>
        <Route
            index
            path={DEFAULT_ROUTE}
            element={
                <SuspendedWithSpinner>
                    <RouteSettingsPageLazy />
                </SuspendedWithSpinner>
            }
        />
        <Route
            path={VEHICLE_ROUTE}
            element={
                <SuspendedWithSpinner>
                    <VehicleOptionsPage />
                </SuspendedWithSpinner>
            }
        />
        <Route
            path={TOUR_SETTINGS_ROUTE}
            element={
                <SuspendedWithSpinner>
                    <TourSettingsPage />
                </SuspendedWithSpinner>
            }
        />
        <Route
            path={SUMMARY_ROUTE}
            element={
                <SuspendedWithSpinner>
                    <RouteSummaryPage />
                </SuspendedWithSpinner>
            }
        />
        <Route
            path={TOUR_HANDLING_ROUTE}
            element={
                <SuspendedWithSpinner>
                    <TourHandlingPage />
                </SuspendedWithSpinner>
            }
        />
        <Route
            path={TOUR_HANDLING_DETAILS}
            element={
                <SuspendedWithSpinner>
                    <TourDetailsManagerPage />
                </SuspendedWithSpinner>
            }
        />
    </Route>
);

export const router = createBrowserRouter(routeObjects);
